import React, { ChangeEventHandler } from 'react';
import { ButtonRow } from '../../Buttons/ButtonRow';

type TSelectPhotosProps = {
    label?: string;
    iconName?: string;
    handleChange: ChangeEventHandler;
};
const SelectPhotos = ({ label, iconName, handleChange }: TSelectPhotosProps) => {
    return (
        <label htmlFor="file">
            <ButtonRow as="div" isWidget={false} label={label} iconName={iconName} />
            <input
                id="file"
                type="file"
                accept=".png,.jpg,.gif,.webp,image/jpeg,image/gif,image/webp,image/png"
                onChange={handleChange}
                style={{ display: 'none' }}
            />
        </label>
    );
};
export { SelectPhotos };
